<template>
    <div>

        <div class="header">
            <strong v-text="`营销账户余额：${marketAccount.chips/100}金豆`"></strong>
            <div class="block">
                <el-input v-model="value" type="number" placeholder="请输入"/>
                <el-button type="primary" @click="clickFunc(1)">增加</el-button>
                <el-button type="primary" @click="clickFunc(-1)">减少</el-button>
                <el-button type="primary" @click="clickFunc(0)">修改为</el-button>
            </div>
        </div>
        <el-card class="common-el-card-flex" style="min-height: 620px">
            <div slot="header">
                <el-date-picker
                        v-model="date"
                        type="datetimerange"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间" @change="dateChange"/>
            </div>

            <el-tabs class="common-el-tabs" v-model="activeName" type="card" @tab-click="$refs[activeName].getList()">
                <el-tab-pane label="修改记录" name="updateLog">
                    <comp-update-log class="common-el-tab-flex" ref="updateLog"/>
                </el-tab-pane>
                <el-tab-pane label="注入彩池记录" name="jpLog">
                    <comp-jp-log class="common-el-tab-flex" ref="jpLog"/>
                </el-tab-pane>
                <el-tab-pane label="赠送记录" name="sendLog">
                    <comp-send-log class="common-el-tab-flex" ref="sendLog"/>
                </el-tab-pane>
                <el-tab-pane label="待手动赠送记录" name="waitingRecordLog">
                    <comp-waiting-record-log class="common-el-tab-flex" ref="waitingRecordLog"/>
                </el-tab-pane>
                <el-tab-pane label="注入跑马灯奖池记录" name="horseRaceLampLog">
                    <comp-horse-race-lamp-log class="common-el-tab-flex" ref="horseRaceLampLog"/>
                </el-tab-pane>
                <el-tab-pane label="系统空抽记录" name="JPSystemChipLog">
                  <comp-system-chip-log class="common-el-tab-flex" ref="JPSystemChipLog"/>
                </el-tab-pane>
                <el-tab-pane label="红包雨中奖记录" name="RedPackLog">
                  <comp-red-pack-log class="common-el-tab-flex" ref="RedPackLog"/>
                </el-tab-pane>
            </el-tabs>
        </el-card>

        <div v-if="show" class="common-popup-bg">
            <div class="common-popup">
                <h3>提示</h3>
                <table class="common-popup-table">
                    <tr>
                        <td style="text-align: center">
                            <template v-if="type === -1">是否确认减少{{value}}金豆到营销账户？</template>
                            <template v-if="type === 1">是否确认增加{{value}}金豆到营销账户？</template>
                            <template v-if="type === 0">是否确认将营销账户余额修改为{{value}}金豆？</template>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-input placeholder="请输入验证码" v-model="code" class="code"></el-input>
                            <btn-countdown @my-click="sendCodeToMyPhone({err:$event.err,type:4})"></btn-countdown>
                        </td>
                    </tr>
                </table>
                <footer>
                    <el-button size="small" @click="closePopup">取消</el-button>
                    <el-button size="small" type="primary" @click="updateChips">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapMutations, mapActions} from 'vuex'
    import btnCountdown from 'components/btnCountdown'
    import compUpdateLog from './compUpdateLog'
    import compJpLog from './compJpLog'
    import compSendLog from './compSendLog'
    import compWaitingRecordLog from './compWaitingRecordLog'
    import compHorseRaceLampLog from './compHorseracelampLog'
    import compRedPackLog from "./compRedPackLog";
    import compSystemChipLog from "./compSystemChipLog";

    export default {
        components: {
            btnCountdown,
            compUpdateLog,
            compJpLog,
            compSendLog,
            compWaitingRecordLog,
            compHorseRaceLampLog,
            compRedPackLog,
            compSystemChipLog
        },
        data() {
            return {
                activeName: 'updateLog',
                show: false,// 修改金豆确认弹窗
                value: '',// 设置的金豆数
                type: '',// 增加 减少 设置为
                code: '',// 短信验证码
                date: '',
            }
        },
        computed: {
            ...mapState('market', ['marketAccount'])
        },
        created() {
            this.getMarketAccount()
        },
        mounted() {
            this.setStateDate('');
            this.$refs[this.activeName].getList()
        },
        methods: {
            ...mapMutations('market', ['setStateDate']),
            ...mapActions('market', ['getMarketAccount', 'setMarketAccountOp']),
            ...mapActions('other', ['sendCodeToMyPhone']),
            // 点击增加 减少 改变金豆数
            clickFunc(type) {
                if (!this.value) {
                    return
                }
                this.show = true;
                this.type = type;
            },
            updateChips() {
                if (!this.code) {
                    this.$message.error('请输入验证码');
                    return
                }
                this.setMarketAccountOp({
                    chips: this.value,
                    code: this.marketAccount.code,
                    msgCode: this.code,
                    op: this.type
                }).then(() => {
                    this.$message.success('修改成功');
                    this.closePopup();
                    if (this.activeName === 'updateLog') {
                        this.$refs[this.activeName].getList();
                    }
                })
            },
            closePopup() {
                this.value = '';
                this.code = '';
                this.show = false;
            },
            dateChange(e) {
                this.setStateDate(e);
                this.$refs[this.activeName].getList()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .header {
        position: relative;
        padding-bottom: 20px;
        line-height: 40px;
    }

    .block {
        display: inline-block;
        padding-left: 100px;
        :global(.el-input) {
            width: 240px;
            margin-right: 10px;
            vertical-align: middle;
        }
    }

    .date {
        padding-bottom: 20px;
    }

    .code {
        width: 180px;
        margin-right: 10px;
    }
</style>